/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    JwtToken,
    JwtTokenFromJSON,
    JwtTokenToJSON,
    Login,
    LoginFromJSON,
    LoginToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
} from '../models';

export interface LoginAuthRequest {
    Login: Login;
}

export interface RefreshTokenAuthRequest {
    JwtToken: JwtToken;
}

export interface RevokeTokenAuthRequest {
    JwtToken: JwtToken;
}

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI {

    /**
     * Use Refresh Tokens
     */
    async authorizeAuthRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<JwtToken>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/oauth/authorize`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JwtTokenFromJSON(jsonValue));
    }

    /**
     * Use Refresh Tokens
     */
    async authorizeAuth(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<JwtToken> {
        const response = await this.authorizeAuthRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async deprecatedRefreshAccessTokenAuthRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/token/refresh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deprecatedRefreshAccessTokenAuth(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<void> {
        await this.deprecatedRefreshAccessTokenAuthRaw(initOverrides);
    }

    /**
     * Log into account
     */
    async loginAuthRaw(requestParameters: LoginAuthRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.Login === null || requestParameters.Login === undefined) {
            throw new runtime.RequiredError('Login','Required parameter requestParameters.Login was null or undefined when calling loginAuth.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginToJSON(requestParameters.Login),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Log into account
     */
    async loginAuth(requestParameters: LoginAuthRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.loginAuthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Log out of account
     */
    async logoutAuthRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Log out of account
     */
    async logoutAuth(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.logoutAuthRaw(initOverrides);
        return await response.value();
    }

    /**
     * Use Refresh Tokens
     */
    async refreshTokenAuthRaw(requestParameters: RefreshTokenAuthRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<JwtToken>> {
        if (requestParameters.JwtToken === null || requestParameters.JwtToken === undefined) {
            throw new runtime.RequiredError('JwtToken','Required parameter requestParameters.JwtToken was null or undefined when calling refreshTokenAuth.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/oauth/token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JwtTokenToJSON(requestParameters.JwtToken),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JwtTokenFromJSON(jsonValue));
    }

    /**
     * Use Refresh Tokens
     */
    async refreshTokenAuth(requestParameters: RefreshTokenAuthRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<JwtToken> {
        const response = await this.refreshTokenAuthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Use Refresh Tokens
     */
    async revokeTokenAuthRaw(requestParameters: RevokeTokenAuthRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<JwtToken>> {
        if (requestParameters.JwtToken === null || requestParameters.JwtToken === undefined) {
            throw new runtime.RequiredError('JwtToken','Required parameter requestParameters.JwtToken was null or undefined when calling revokeTokenAuth.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/oauth/revoke`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JwtTokenToJSON(requestParameters.JwtToken),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JwtTokenFromJSON(jsonValue));
    }

    /**
     * Use Refresh Tokens
     */
    async revokeTokenAuth(requestParameters: RevokeTokenAuthRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<JwtToken> {
        const response = await this.revokeTokenAuthRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
